module.exports = __webpack_public_path__ + "ed0207d3300dd0b99d7993f49578ddc2.svg";